import { render, staticRenderFns } from "./SocialHub.vue?vue&type=template&id=540b7442&scoped=true&"
import script from "./SocialHub.vue?vue&type=script&lang=js&"
export * from "./SocialHub.vue?vue&type=script&lang=js&"
import style0 from "./SocialHub.vue?vue&type=style&index=0&id=540b7442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b7442",
  null
  
)

export default component.exports